import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  getAmountWithCurrency,
  TranslationKeys,
  UpdatedFreeBetDataItemKeys,
  useTranslation,
} from '@pascal/pascal-core';
import { doBetStore } from '../../../store/doBetStore';

export const MaxPayOutPopUp = observer(() => {
  const t = useTranslation();
  const { maxPayoutData } = doBetStore;
  return (
    <>
      {Object.keys(maxPayoutData).map((item) => {
        const { isAlreadySeenPopUp, isShowPopUp, maxPayout, freeBetId } = maxPayoutData[item];
        return (
          <React.Fragment key={item}>
            {isShowPopUp && !isAlreadySeenPopUp && freeBetId ? (
              <div className='free-bet-popup max-payout'>
                <div className='free-bet-popup-content cashout'>
                  <div className='free-bet-popup-content-inner'>
                    <div className='free-bat-cashout-bl'>
                      <p>{t(TranslationKeys.FreeBetMaxWinPayout)}</p>
                      <span>{getAmountWithCurrency({ amount: maxPayout })}</span>
                      <button
                        className='cashout-btn'
                        onClick={() => {
                          doBetStore.updateMaxPayoutBetData({
                            sectionId: Number(item),
                            updatedDataByKeys: {
                              [UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP]: false,
                              [UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP]: true,
                            },
                          });
                        }}
                      >
                        {t(TranslationKeys.Ok)}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
    </>
  );
});
